// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/icon-search.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReactBased .CustomerSelect {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.ReactBased .CustomerSelect .customerNotSelectedErrorMsg {
  font-size: 14px;
  font-weight: 500;
  color: #D92D20;
  margin-left: 32px;
}
.ReactBased .CustomerSelect > div.autoComplete > div {
  background-color: #FFF;
}
.ReactBased .CustomerSelect > div.autoComplete > div > input.Controlled {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 5px;
  padding-left: 25px;
}
.ReactBased .SubscribeToUnlockCustomers {
  padding: none !important;
  border-top: 1px solid #E8E9F0;
  margin-top: 10px !important;
  padding-top: 10px !important;
  padding-bottom: 20px !important;
  height: auto !important;
  padding-left: 8px;
  padding-right: 8px;
}
.ReactBased .SubscribeToUnlockCustomers__header {
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
}
.ReactBased .SubscribeToUnlockCustomers__action {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.ReactBased .SubscribeToUnlockCustomers__action span {
  font-size: 14px !important;
}
.ReactBased div.CustomerSelector {
  margin-top: 46px;
  margin-left: 36px;
  margin-bottom: 48px;
  font-size: 14px;
}
.ReactBased div.CustomerSelector .CustomerLabel,
.ReactBased div.CustomerSelector .CustomerChange {
  display: inline;
  margin-right: 20px;
}
.ReactBased div.CustomerSelector .CustomerLabel .Button.link,
.ReactBased div.CustomerSelector .CustomerChange .Button.link {
  font-size: 14px;
}
.ReactBased div.CustomerSelector .CustomerLabel {
  font-size: 14px;
  font-weight: 700;
  color: #002E33;
}
.ReactBased div.CustomerSelector .CustomerSelect.invalid div.autoComplete input {
  border: 1px solid #951307;
  background-color: rgba(149, 19, 7, 0.2);
}
.ReactBased div.CustomerSelector .CustomerAddress {
  display: block;
  margin-top: 40px;
  font-weight: 500;
  color: #002E33;
  white-space: pre-line;
}
.ReactBased div.CustomerSelector .CustomerAddress .customerName {
  margin: 0 0 12px 0;
  font-weight: 700;
  color: #002E33;
}
.ReactBased div.CustomerSelector .CustomerAddress .Button.link {
  font-size: 14px;
}
.ReactBased div.CustomerSelector .ShippingAddress {
  margin: 12px 0;
  font-size: 13px;
  font-weight: 500;
  color: #002E33;
}
.ReactBased div.CustomerSelector .CustomerSelect {
  margin-top: 16px;
}
.ReactBased div.CustomerSelector .CustomerSelect input.Controlled {
  font-size: 14px;
  height: 40px;
}
.ReactBased div.CustomerSelector .CustomerSelect .menu-items > div {
  font-size: 14px !important;
  height: 20px;
}
.ReactBased div.CustomerSelector .CustomerSelect .action-btn {
  font-size: 14px;
}
.ReactBased div.CustomerSelector .CustomerSelect span.jewel {
  height: 38px;
  width: 37px;
  left: calc(100% - 38px);
}`, "",{"version":3,"sources":["webpack://./src/client/components/CustomerSelector/CustomerSelect.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAKE;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;AAJJ;AAMI;EACE,eAAA;EACA,gBAAA;EACA,cCDA;EDEA,iBAAA;AAJN;AAOI;EACE,sBCTE;ADIR;AAOM;EACE,iEAAA;EACA,kBAAA;AALR;AAUE;EACE,wBAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,+BAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AARJ;AAUI;EACE,kBAAA;EACA,iBAAA;EACA,oBAAA;AARN;AAWI;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;AATN;AAWM;EACE,0BAAA;AATR;AAcE;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AAZJ;AAcI;;EAEE,eAAA;EACA,kBAAA;AAZN;AAcM;;EACE,eAAA;AAXR;AAeI;EACE,eAAA;EACA,gBAAA;EACA,cCtES;ADyDf;AAgBI;EACE,yBAAA;EACA,uCAAA;AAdN;AAiBI;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,cClFS;EDmFT,qBAAA;AAfN;AAiBM;EACE,kBAAA;EACA,gBAAA;EACA,cCxFO;ADyEf;AAkBM;EACE,eAAA;AAhBR;AAoBI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cCpGS;ADkFf;AAqBI;EACE,gBAAA;AAnBN;AAqBM;EACE,eAAA;EACA,YAAA;AAnBR;AAsBM;EACE,0BAAA;EACA,YAAA;AApBR;AAuBM;EACE,eAAA;AArBR;AAwBM;EACE,YAAA;EACA,WAAA;EACA,uBAAA;AAtBR","sourcesContent":[".ReactBased {\n  @import '../../Global/Colors';\n\n\n\n  .CustomerSelect {\n    display: flex;\n    align-items: center;\n\n    .customerNotSelectedErrorMsg {\n      font-size: 14px;\n      font-weight: 500;\n      color: $Red;\n      margin-left: 32px;\n    }\n\n    >div.autoComplete>div {\n      background-color: $White;\n\n      >input.Controlled {\n        background: url('~images/icon-search.png') no-repeat 5px;\n        padding-left: 25px;\n      }\n    }\n  }\n\n  .SubscribeToUnlockCustomers {\n    padding: none !important;\n    border-top: 1px solid $Gray30;\n    margin-top: 10px !important;\n    padding-top: 10px !important;\n    padding-bottom: 20px !important;\n    height: auto !important;\n    padding-left: 8px;\n    padding-right: 8px;\n\n    &__header {\n      text-align: center;\n      padding-top: 10px;\n      padding-bottom: 10px;\n    }\n\n    &__action {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      span {\n        font-size: 14px !important;\n      }\n    }\n  }\n\n  div.CustomerSelector {\n    margin-top: 46px;\n    margin-left: 36px;\n    margin-bottom: 48px;\n    font-size: 14px;\n\n    .CustomerLabel,\n    .CustomerChange {\n      display: inline;\n      margin-right: 20px;\n\n      .Button.link {\n        font-size: 14px;\n      }\n    }\n\n    .CustomerLabel {\n      font-size: 14px;\n      font-weight: 700;\n      color: $DeepSeaGreen;\n    }\n\n    .CustomerSelect.invalid div.autoComplete input {\n      border: 1px solid $Red120;\n      background-color: rgba($Red120, 0.2);\n    }\n\n    .CustomerAddress {\n      display: block;\n      margin-top: 40px;\n      font-weight: 500;\n      color: $DeepSeaGreen;\n      white-space: pre-line;\n\n      .customerName {\n        margin: 0 0 12px 0;\n        font-weight: 700;\n        color: $DeepSeaGreen;\n      }\n\n      .Button.link {\n        font-size: 14px;\n      }\n    }\n\n    .ShippingAddress {\n      margin: 12px 0;\n      font-size: 13px;\n      font-weight: 500;\n      color: $DeepSeaGreen;\n    }\n\n    .CustomerSelect {\n      margin-top: 16px;\n\n      input.Controlled {\n        font-size: 14px;\n        height: 40px;\n      }\n\n      .menu-items>div {\n        font-size: 14px !important;\n        height: 20px;\n      }\n\n      .action-btn {\n        font-size: 14px;\n      }\n\n      span.jewel {\n        height: 38px;\n        width: 37px;\n        left: calc(100% - 38px);\n      }\n    }\n  }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
